export const ruTS = [
  'OK',
  'Не предусмотрено',
  'Хруст',
  'Нет',
  'Да',
  'Вибрация',
  'Вмятина без повреждения ЛКП',
  'Вмятина с повреждения ЛКП',
  'Гул',
  'Деталь перекрашена',
  'Запотевание',
  'Износ',
  'Износ более 70%',
  'Износ опоры',
  'Износ пыльника',
  'Износ пыльников',
  'Износ щеток',
  'Коррозия',
  'Люфт',
  'Механические повреждения',
  'Не закреплена',
  'Не обнаружено',
  'Не работает',
  'Некорректная работа',
  'Необходимо долить',
  'Обнаружена эмульсия',
  'Отслоения',
  'Отсутствует/Не подключена',
  'Охлаждение не работает',
  'Повреждение ЛКП',
  'Повреждение обшивок',
  'Повреждение троса',
  'Повреждения пневмоподушки',
  'Подогрев не работает',
  'Порезы',
  'Посторонний шум',
  'Присутствуют коды неисправностей',
  'Пробуксовка',
  'Пробуксовка дифференциала',
  'Пробуксовка скоростей КПП',
  'Прожоги',
  'Прослабление',
  'Разрывы',
  'Разрывы от выстрела AirBag',
  'Разряжен',
  'Расслоения',
  'Расход масла/Выделение картерных газов',
  'Расход масла/Выделение картерных газов/Дым',
  'Система пустая',
  'Сколы',
  'Следы сварочных работ',
  'Стук',
  'Стуки',
  'Течь',
  'Только с двери',
  'Только с центрального блока',
  'Тормозные колодки',
  'Требуется замена',
  'Трещины',
  'Управления на руле не работает',
  'Установлена/требует подключения/ремонта',
  'Утечка газа',
  'Царапины',
  'Шум',
  'Клапанная крышка',
  'ГБЦ',
  'Механизм газораспределения',
  'Блок картера',
  'Поддон картера',
  'Система  впуска',
  'Система выпуска',
  'Турбина/компрессор',
  'Датчики/Блоки управления двигателя',
  'Приводные ремни',
  'Уровень масла ДВС',
  'Наличие эмульсии в моторном масле',
  'Упоры капота',
  'АКБ',
  'Стартер',
  'Генератор',
  'ГБО',
  'Механизм сцепления (Для МКПП)',
  'Гидромуфта (Для АКПП)',
  'Гидротрасформатор (Для АКПП)',
  'Селектор переключения',
  'Поддон КПП',
  'Раздаточная коробка',
  'Передний редуктор',
  'Задний Редуктор',
  'Датчики/Блоки управления КПП',
  'Основной радиатор',
  'Водяной насос',
  'Термостат',
  'Вентиляторы/Интеркуллеры/масляный радиатор КПП',
  'Датчики/Блоки управления СО',
  'Уровень охлаждающей жидкости',
  'Передние лонжероны',
  'Задние лонжероны',
  'Передние амортизаторы',
  'Задние амортизаторы',
  'Передние пружины',
  'Задние пружины',
  'Передние салейнтблоки',
  'Задние салейнтблоки',
  'Передние рычаги подвески',
  'Задние рычаги подвески',
  'Передние стойки стабилизатора',
  'Задние стойки стабилизатора',
  'Передние втулки стабилизатора',
  'Задние втулки стабилизатора',
  'Опоры двигателя',
  'Опоры КПП',
  'Опоры подвески',
  'Шаровые опоры',
  'Датчики/Блоки управления ходовой части',
  'Ступица',
  'ШРУС',
  'Привод',
  'Карданный шарнир',
  'Датчики/Блоки управления привода колес',
  'Тормозные диски (барабаны)',
  'Тормозные диски (барабаны)',
  'Главный тормозной цилиндр',
  'Вакуумный цилиндр',
  'Тормозные Суппорта',
  'Тормозные шланги',
  'Ручной тормоз',
  'Уровень тормозной жидкости',
  'Датчики/Блоки управления тормозной системы',
  'Рулевая рейка',
  'Рулевые тяги',
  'Рулевые наконечники',
  'Насос ГУР',
  'Рулевая колонка',
  'Уровень жидкости ГУР',
  'Датчики/Блоки управления рулевого управления',
  'Компрессор кондиционера',
  'Радиатор кондиционера',
  'Радиатор печки',
  'Вентилятор печки',
  'Заслонки печки',
  'Трубки',
  'Фреон',
  'Датчики/Блоки управления отопления',
  'Подушка безопасности водителя',
  'Подушка безопасности пассажира',
  'Подушки безопасности боковые',
  'Подушки безопасности шторки',
  'Ремни безопасности/пиропатроны',
  'Датчики/Блоки управления безопасности',
  'Крыло переднее левое',
  'Крыло переднее правое',
  'Крыло заднее правое',
  'Крыло заднее левое',
  'Дверь передняя левая',
  'Дверь задняя левая',
  'Дверь передняя правая',
  'Дверь задняя правая',
  'Крыша',
  'Капот',
  'Крышка багажника',
  'Бампер передний',
  'Бампер задний',
  'Панель облицовки радиатора',
  'Стойка задняя левая',
  'Стойка передняя левая',
  'Стойка передняя правая',
  'Стойка задняя правая',
  'Стойка центральная левая',
  'Стойка центральная правая',
  'Порог левый',
  'Порог правый',
  'Лонжерон передний правый',
  'Лонжерон передний левый',
  'Лонжерон задний правый',
  'Лонжерон задний левый',
  'Ниша запасного колеса',
  'Рама кузова',
  'Днище',
  'Заднее левое стекло',
  'Переднее левое стекло',
  'Переднее правое стекло',
  'Заднее правое стекло',
  'Лобовое стекло',
  'Заднее стекло',
  'Задняя правая форточка',
  'Задняя левая форточка',
  'Люк/панорамная крыша',
  'Передняя левая фара',
  'Передняя правая фара',
  'Передняя левая ПТФ',
  'Передняя правая ПТФ',
  'Задняя левая фар',
  'Задняя правая фара',
  'Дополнительный стоп-сигнал',
  'Зеркало левое',
  'Зеркало правое',
  'Передний левый поворотник на крыле',
  'Передний правый поворотник на крыле',
  'Запасное колесо',
  'Диск',
  'Резина',
  'Передний правый габарит',
  'Передний левый габарит',
  'Лампа ближнего света правая',
  'Лампа ближнего света левая',
  'Лампа дальнего света правая',
  'Лампа дальнего света левая',
  'Ходовой огонь правый',
  'Ходовой огонь левый',
  'Лампа ПТФ передняя правая',
  'Лампа ПТФ передняя левая',
  'Поворотники фар правые',
  'Поворотники фар левые',
  'Поворотники переднего правого крыла',
  'Поворотники переднего левого крыла',
  'Поворотник правого зеркала',
  'Поворотник левого зеркала',
  'Задний правый габарит',
  'Задний левый габарит',
  'Стоп-сигнал правый',
  'Стоп-сигнал левый',
  'Лампа дополнительного стоп-сигнала',
  'Подсветка номера',
  'Задний ход правый',
  'Задний ход левый',
  'Поворотник правый задний',
  'Поворотник левый задний',
  'Лампа ПТФ задняя левая',
  'Лампа ПТФ задняя правая',
  'Сиденье водительское',
  'Сиденье пассажирское',
  'Задний ряд сидений',
  'Дополнительные ряд сидений',
  'Дверная карта передняя левая',
  'Дверная карта передняя правая',
  'Дверная карта задняя левая',
  'Дверная карта задняя правая',
  'Подлокотники',
  'Селектор КПП (селектор+чехол)',
  'Рулевое колесо',
  'Приборная панель',
  'Потолочное покрытие',
  'Ковровое покрытие пол',
  'Уплотнительные резинки',
  'Багажное отделение',
  'Звуковой сигнал',
  'Стеклоподъемник передний левый',
  'Стеклоподъемник передний правый',
  'Стеклоподъемник задний левый',
  'Стеклоподъемник задний правый',
  'Регулировка правого зеркала + зеркальный элемент',
  'Регулировка левого зеркала + зеркальный элемент',
  'Электоскладывание зеркала левое',
  'Электоскладывание зеркала правое',
  'Центральный замок передней правой двери',
  'Центральный замок передней левой двери',
  'Центральный замок задней левой двери',
  'Центральный замок задней правой двери',
  'Центральный замок крышки багажника',
  'Стеклоочистители передние',
  'Стеклоочистители задние',
  'Омыватели стекла передние',
  'Омыватели стекла задние',
  'Омыватели фар',
  'Мультимедийная система',
  'Система отопления салона и работа режимов смены потоков воздуха',
  'Система кондиционирования',
  'Регулировка руля по вылету/наклону',
  'Регулировки водительского сиденья',
  'Регулировки пассажирского сиденья',
  'Регулировки задних рядов сидений',
  'Подогрев/охлаждение водительского сиденья',
  'Подогрев/охлаждение пассажирского сиденья',
  'Подогрев/охлаждение задних рядов сидений',
  'Состояние ЛКП (в микронах)',
  'Химчистка',
  'Полировка'
]

export const kzTS = [
  'OK',
  'Не предусмотрено',
  'Хруст',
  'Нет',
  'Да',
  'Діріл',
  'ЛБӨ бүлдірместен жапырылған жер',
  'ЛБӨ бүлінген жапырылған жер',
  'Гуіл',
  'Бөлшегі боялған',
  'Булануы',
  'Тозуы',
  'Тозуы 70% астам көлемді құрайды',
  'Тіреудің тозуы',
  'Тозаңдықтың тозуы',
  'Тозаңдықтардың тозуы',
  'Қылшақтардың тозуы',
  'Тот басу',
  'Люфт',
  'Механикалық бүлінулер',
  'Бекітілмеген',
  'Табылмаған',
  'Жұмыс істемейді',
  'Қате жұмыс',
  'Үстемелеп құю қажет',
  'Эмульсия табылған',
  'Қатпарлануы',
  'Жоқ/Қосылмаған',
  'Салқындатуы жұмыс істемейді',
  'ЛБӨ бүлінуі',
  'Қаптаманың бүлінуі',
  'Тростың бүлінуі',
  'пневмо-жастықтың бүлінуі',
  'Жылытуы жұмыс істемейді',
  'Тілімдер',
  'Бөгде шу',
  'Олқылық кодтары бар',
  'Батып қалуы',
  'Дифференциалдың батып қалуы',
  'БАҚ жылдамдықтарының тұрып қалуы',
  'Күйіктеспелер',
  'босаңсыту',
  'Ажыраулар',
  'AirBag атысынан үзілулер',
  'Қуат көзі таусылған',
  'Қабаттасулар',
  'Майдың шығыны/Картерлік газдардың бөлінуі',
  'Майдың шығыны/Картерлік газдардың бөлінуі/Түтін',
  'Жүйе бос',
  'Сынықтар',
  'Дәнекерлеу жұмыстарының іздері',
  'Тоқыл',
  'Тоқыл',
  'Ағып кетуі',
  'Тек есіктен',
  'Тек орталық блоктан',
  'Тежегіш қалыптары',
  'Ауыстыру талап етіледі',
  'Жарықтар',
  'Рульден басқару жұмыс істемейді',
  'Орнатылған/қосуды/жөндеу талап етіледі',
  'Газдың жылыстауы',
  'Сызаттар',
  'Шу',
  'Клапандық қақпақ',
  'ЦББ',
  'Газ бөлу механизмі',
  'Картер блогы',
  'Картер табаны',
  'Іске қосу жүйесі',
  'Шығару жүйесі',
  'Турбина/компрессор',
  'Датчиктер/Қозғалтқышты басқару блоктары',
  'Жетек белдіктері',
  'ІТҚ майының деңгейі',
  'Мотор майында эмульсияның болуы',
  'Қақпақ тіреулері',
  'АКБ',
  'Стартер',
  'Генератор',
  'ГБО',
  'Ілінісу механизмі (МБҚ үшін)',
  'Гидромуфта (Для АКПП)',
  'Гидротрасформатор (АБҚ үшін)',
  'Ауыстыру селекторы',
  'БАҚ табаны',
  'Тарату қорабы',
  'Алдыңғы редуктор',
  'Артқы редуктор',
  'Датчиктер/БАҚ басқару блоктары',
  'Негізгі радиатор',
  'Су сорғысы',
  'Термостат',
  'Желдеткіштер/интеркуллерлер/БАҚ май радиаторы',
  'Датчиктер/СО басқару блоктары',
  'Салқындату сұйықтығының деңгейі',
  'Алдыңғы лонжерондар',
  'Артқы лонжерондар',
  'Алдыңғы амортизаторлар',
  'Артқы амортизаторлар',
  'Алдыңғы серіппелер',
  'Артқы серіппелер',
  'Алдыңғы салейнтблоктар',
  'Артқы салейнтблоктар',
  'Аспаның алдыңғы тетіктері',
  'Аспаның артқы тетіктері',
  'Тұрақтандырғыштың алдыңғы тіреулері',
  'Тұрақтандырғыштың артқы тіреулері',
  'Тұрақтандырғыштың алдыңғы төлкелері',
  'Тұрақтандырғыштың артқы төлкелері',
  'Қозғалтқыштың тіреулері',
  'БАҚ тіреулері',
  'Аспаның тіреулері',
  'Шар тіреулері',
  'Датчиктер/Жүріс бөлігін басқару блоктары',
  'Күпшек',
  'ШРУС',
  'Жетек  ',
  'Кардан топсасы',
  'Датчиктер/дөңгелектер жетегін басқару блоктары',
  'Тежегіш дискілері (барабандар)',
  'Тежегіш дискілері (барабандар)',
  'Бас тежегіш цилиндр',
  'Вакуум цилиндрі',
  'Тежегіш суппорты',
  'Тежегіш құбыршектері',
  'Қол тежегіші',
  'Тежегіш сұйықтығының деңгейі',
  'Датчиктер/Тежегіш жүйесін басқару блоктары',
  'Рульдік рейка',
  'Рульдік тартқыштар',
  'Рульдік ұштықтар',
  'РГК сорғысы',
  'Рульдік колонка',
  'РГК сұйықтығының деңгейі',
  'Датчиктер/Рульдік басқару блоктары',
  'Кондиционердің компрессоры',
  'Кондиционердің радиаторы',
  'Пеш радиаторы',
  'Пеш желдеткіші',
  'Пеш жапқышы',
  'Түтіктер',
  'Фреон',
  'Датчиктер/Жылытуды басқару блоктары',
  'Жүргізуші қауіпсіздігінің жастығы',
  'Жолаушы қауіпсіздігінің жастығы',
  'Бүйірлік қауіпсіздік жастықтары',
  'Перде қауіпсіздігінің жастықтары',
  'Қауіпсіздік белдіктері/пиропатрондары',
  'Датчиктер/Қауіпсіздікті басқару блоктары',
  'алдыңғы сол жақ қанаты',
  'Алдыңғы оң жақ қанаты',
  'Артқы оң жақ қанаты',
  'Артқы сол жақ қанаты',
  'Алдыңғы сол жақ есігі',
  'Артқы сол жақ есігі',
  'Алдыңғы оң жақ есігі',
  'Артқы оң жақ есігі',
  'Төбесі',
  'Капот',
  'Жүк салғыштың қақпағы',
  'Алдыңғы бампер',
  'Артқы бампер',
  'Радиатор қаптамасының панелі',
  'Артқы сол жақ тіреуі',
  'Алдыңғы сол жақ тіреуі',
  'Алдыңғы оң жақ тіреуі',
  'Артқы оң жақ тіреуі',
  'Орталық сол жақ тіреуі',
  'Орталық оң жақ тіреуі',
  'Сол жақ табаны',
  'Оң жақ табаны',
  'Алдыңғы оң жақ лонжероны',
  'Алдыңғы сол жақ лонжероны',
  'Артқы оң жақ лонжероны',
  'Артқы сол жақ лонжероны',
  'Артық дөңгелек қуысы',
  'Шанақ жиектемесі',
  'Түбі',
  'Артқы сол жақ шынысы',
  'Алдыңғы сол жақ шынысы',
  'Алдыңғы оң жақ шынысы',
  'Артқы оң жақ шынысы',
  'Бүйірлік шыны',
  'Артқы шыны',
  'Артқы оң жақ терезе желдеткіші',
  'Артқы сол жақ терезе желдеткіші',
  'Люк/панорамалық қақпағы',
  'Алдыңғы сол жақ шамы',
  'Алдыңғы оң жақ шамы',
  'Алдыңғы сол жақ ПТФ',
  'Алдыңғы оң жақ ПТФ',
  'Артқы сол жақ шамы',
  'Артқы оң жақ шамы',
  'Қосымша стоп-белгі',
  'Сол жақ айнасы',
  'Оң жақ айнасы',
  'Қанатындағы алдыңғы сол жақ бұрғышы',
  'Қанатындағы алдыңғы оң жақ бұрғышы',
  'Артық дөңгелек  ',
  'Диск',
  'Резеңке',
  'Алдыңғы оң жақ габариті',
  'Алдыңғы сол жақ габариті',
  'Оң жақ жақын жарық шамы',
  'Сол жақ жақын жарық шамы',
  'Оң жақ алыс жарық шамы',
  'Сол жақ алыс жарық шамы',
  'Оң жақ жүріс оты',
  'Сол жақ жүріс оты',
  'Алдыңғы оң жақ ПТФ шамы',
  'Алдыңғы сол жақ птФ шамы',
  'Оң жақ шамдарының бұрғыштары',
  'Сол жақ шамдарының бұрғыштары',
  'Алдыңғы оң жақ қанатының бұрғыштары',
  'Алдыңғы сол жақ қанатының бұрғыштары',
  'Алдыңғы айна бұрғышы',
  'Сол жақ айна бұрғышы',
  'Артқы оң жақ габариті',
  'Артқы сол жақ габариті',
  'Оң жақ тоқтату белгісі',
  'Сол жақ тоқтату белгісі',
  'Қосымша тоқтату белгісінің шамы',
  'Нөмірдің жарығы',
  'Оң жақ артқы жүріс',
  'Сол жақ артқы жүріс',
  'Оң жақ артқы бұрғыш',
  'Сол жақ артқы бұрғыш',
  'Артқы сол жақ ПТФ шамы',
  'Артқы оң жақ ПТФ шамы',
  'Жүргізушінің орындығы',
  'Жолаушының орындығы',
  'Орындықтардың артқы қатары',
  'Орындықтардың қосымша қатары',
  'Алдыңғы сол жақ есік картасы',
  'Алдыңғы оң жақ есік картасы',
  'Артқы сол жақ есік картасы',
  'Артқы оң жақ есік картасы',
  'Шынтақ сүйегіштері',
  'БАҚ селекторы (селектор+тысы)',
  'Рульдік дөңгелек',
  'Аспаптық панель',
  'Төбе жабыны',
  'Еденнің кілем жабыны',
  'Тығыздандырғыш резеңкелер',
  'Жүк салғыш бөлімі',
  'Дыбыстық белгі',
  'Алдыңғы сол жақ шыны көтергіші',
  'Алдыңғы оң жақ шыны көтергіші',
  'Артқы сол жақ шыны көтергіші',
  'Артқы оң жақ шыны көтергіші',
  'Оң жақ айнаны реттеу + айна элементі',
  'Сол жақ айнаны реттеу + айна элементі',
  'Сол жақ айнаны электрлік жинау',
  'Оң жақ айнаны электрлік жинау',
  'Алдыңғы оң жақ есіктің орталық құлпы',
  'Алдыңғы сол жақ есіктің орталық құлпы',
  'Артқы сол жақ есіктің орталық құлпы',
  'Артқы оң жақ есіктің орталық құлпы',
  'Жүк салғыш қақпағының орталық құлпы',
  'Алдыңғы шыны тазалағыштар',
  'Артқы шыны тазалағыштар',
  'Алдыңғы шыны шайғыштары',
  'Артқы шыны шайғыштары',
  'Шамдардың шайғыштары',
  'Мультимедиялық жүйе',
  'Ауа ағымдарын ауыстыру тәртіптерінің жұмысы және салонды жылыту жүйесі',
  'Кондиционерлеу жүйесі',
  'Ұшу/ылдилық бойынша рульді реттеу',
  'Жүргізушінің орындығын реттеу',
  'Жолаушының орындығын реттеу',
  'Орындықтардың артқы қатарларын реттеу',
  'Жүргізуші орындығын қыздыру/салқындату',
  'Жолаушының орындығын қыздыру/салқындату',
  'Орындықтардың артқы қатарын қыздыру/салқындату',
  'ЛКП күйі (микрондарда)',
  'Химиялық тазалау',
  'Жылтырату'
]

const technicalInspectionList = [
  'technicalInspectionBrakeSystem',
  'technicalInspectionCoolingSystem',
  'technicalInspectionEngine',
  'technicalInspectionHeating',
  'technicalInspectionPowerSupply',
  'technicalInspectionSafety',
  'technicalInspectionSteering',
  'technicalInspectionSuspension',
  'technicalInspectionTransmission',
  'technicalInspectionWheelDrive',
  'inspectionExternalPurch',
  'inspectionInternalPurch'
]

export const getDamagedParts = value => {
  let damagedParts = []
  let damagedPartsKZ = []

  const getFormatted = type => {
    if (!value[type]) return

    Object.keys(value[type]).forEach(key => {
      const obj = value?.[type]?.[key]

      if (
        [
          'addSeatsRow',
          'armrests',
          'carpetedFloor',
          'doorCardFrontLeft',
          'doorCardFrontRight',
          'doorCardRearLeft',
          'doorCardRearRight',
          'luggageSpace',
          'panel',
          'rearSeats',
          'roofCover',
          'sealantRubbers',
          'seatDriver',
          'seatPassangerState',
          'selectorTransmissionAndHolder',
          'wheel'
        ].includes(key)
      )
        return

      if (
        type === 'inspectionExternalPurch' &&
        ![
          'longeronFrontLeft',
          'longeronFrontRight',
          'longeronRearLeft',
          'longeronRearRight'
        ].includes(key)
      )
        return

      if (
        obj?.state?.includes('OK') ||
        obj?.state?.includes('Не предусмотрено')
      )
        return

      const name = kzTS[ruTS.findIndex(v => v === obj.name)]
      const stateIndex = val => ruTS.findIndex(v => v === val)

      const state = obj?.state

      if (state.length === 0) {
        return
      }

      damagedParts.push({
        name: obj?.name,
        cause: state
          ?.filter(x => x !== '' && x !== 'Заводской окрас детали')
          ?.map(state => state)
          ?.join(', ')
      })
      damagedPartsKZ.push({
        name,
        cause: state
          ?.filter(x => x !== '' && x !== 'Заводской окрас детали')
          ?.map(state => kzTS[stateIndex(state)])
          ?.filter(e => e)
          ?.join(', ')
      })
    })
  }

  technicalInspectionList.forEach(inspectionType =>
    getFormatted(inspectionType)
  )

  return { ru: damagedParts, kz: damagedPartsKZ }
}
